/**
 * *******************************************************************************************************************
 * Responsibility - Since the size for the thumbnail in magnifyImage component comes from the design object, we need to
 * adjust it to fit the parent component. 🐺
 * *****************************************
 *
 * @format
 */

import React, {useEffect, useRef} from 'react';
import {MagnifyImage} from 'frontier-utilities';

export const ResponsiveWidthImageThumbnail = props => {
    const {currentImgSource, designOrder} = props;
    const containerRef = useRef(null);

    useEffect(() => {
        if (containerRef.current) {
            const parent = containerRef.current.querySelector('.magnify-container > div');
            const image = containerRef.current.querySelector('img');
            const width = containerRef.current.offsetWidth;

            if (image && image.style && parent && parent.style) {
                image.style.width = `${width}px`;
                image.style.height = 'auto';

                parent.style.width = `${width}px`;
                parent.style.height = 'auto';
            }
        }
    }, [currentImgSource]);

    const shouldUseEnlargedMagnifier =
        designOrder.design.pressready_thumb_width / designOrder.design.pressready_thumb_height >
        3.5;

    return (
        <div ref={containerRef} className="w-100">
            <MagnifyImage
                hasSpotwhiteLayer={!!designOrder.design.pressready_spotwhite_thumb_signed_url}
                height={designOrder.design.pressready_thumb_height}
                backgroundStyle={{background: 'none', padding: 0}}
                width={designOrder.design.pressready_thumb_width}
                magnifiedImageHeight={shouldUseEnlargedMagnifier ? 5 : undefined}
                magnifiedImageWidth={shouldUseEnlargedMagnifier ? 5 : undefined}
                src={currentImgSource}
                isHintEnabled={false}
                showDownload={false}
            />
        </div>
    );
};
